import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { providePrimeNG } from 'primeng/config';
import { MessageService, ConfirmationService } from 'primeng/api';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';

// Thème PrimeNG aligné sur l'identité de marque Bitha (mêmes couleurs que les
// variables --bitha-* de styles.scss, partagées avec l'app frontend publique).
const BithaPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#eef5fc',
      100: '#d3e6f7',
      200: '#a7cdef',
      300: '#7bb3e6',
      400: '#4f9ade',
      500: '#1976D2',
      600: '#0D47A1',
      700: '#0a3a83',
      800: '#082c57',
      900: '#051f3f',
      950: '#031326'
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: BithaPreset,
        options: {
          darkModeSelector: false
        }
      }
    }),
    MessageService,
    ConfirmationService
  ]
};
